import { render, staticRenderFns } from "./BlanketVOBCreate.vue?vue&type=template&id=47b2af02&scoped=true"
import script from "./BlanketVOBCreate.vue?vue&type=script&lang=js"
export * from "./BlanketVOBCreate.vue?vue&type=script&lang=js"
import style0 from "./BlanketVOBCreate.vue?vue&type=style&index=0&id=47b2af02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b2af02",
  null
  
)

export default component.exports